import OrderControlManagePage from './OrderControlManagePage';

export default function OrderControlSpecificUserPage() {
  return <OrderControlManagePage mode="personal" title="控特定用戶" />;
}
